import isUrl from 'is-url';

const getRequiredValidation = (
  requiredValidationMessage: string,
) => ({
  required: requiredValidationMessage,
});

const getAtLeastOneElementRequiredValidation = (
  requiredValidationMessage: string,
) => ({
  validate: (value: string) => (
    value.length > 0 || requiredValidationMessage
  ),
});

const getEmailValidation = (
  emailValidationMessage: string,
  requiredValidationMessage: string,
) => ({
  required: requiredValidationMessage,
  pattern: {
    message: emailValidationMessage,
    // eslint-disable-next-line @stylistic/max-len
    value: /^([\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)*)?$/,
  },
});

const getPasswordValidation = (
  passwordTooShortMessage: string,
  requiredValidationMessage: string,
) => ({
  required: requiredValidationMessage,
  minLength: {
    value: 12,
    message: passwordTooShortMessage,
  },
});

const getUrlValidation = (
  urlValidationMessage: string,
  requiredValidationMessage: string,
  allowRelative?: boolean,
) => ({
  required: requiredValidationMessage,
  validate: (value: string) => (
    !value
    || isUrl(value)
    || ((allowRelative ?? false) && value.startsWith('/'))
    || urlValidationMessage
  ),
});

const getApplyUrlValidation = (
  urlValidationMessage: string,
  requiredValidationMessage: string,
  showApplyUrl: boolean,
) => ({
  validate: (value: string) => (value
    ? isUrl(value) || urlValidationMessage
    : !showApplyUrl || requiredValidationMessage
  ),
});

const getSlugValidation = () => ({
  pattern: {
    message: 'Slugs must use only lowercase characters, number and hyphens',
    value: /^[\da-z-]+$/,
  },
});

const isLatitude = (coordinate: number) => Math.abs(coordinate) <= 90;
const isLongitude = (coordinate: number) => Math.abs(coordinate) <= 180;

const getGeolocationValidation = (
  validationMessage: string,
) => ({
  validate: (value: string[]) => (
    value.length === 0
    || (isLatitude(Number(value[0])) && isLongitude(Number(value[1])))
    || validationMessage
  ),
});

export {
  getRequiredValidation,
  getAtLeastOneElementRequiredValidation,
  getEmailValidation,
  getPasswordValidation,
  getUrlValidation,
  getApplyUrlValidation,
  getSlugValidation,
  isLatitude,
  isLongitude,
  getGeolocationValidation,
};
